import { gql } from "@apollo/client";

export const driver = gql`
  fragment driver on Driver {
    id
    uniqueID
    firstName
    lastName
    phoneNumber
    identityCardNo
    agreesWithPersonalDataUse
  }
`;
